// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Flight from '../_raw/service/icon_flight.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Flight);
